/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { head } from 'lodash';
import { Grid } from 'web-ui-components/lib/layout/grids';
import { SectionHeading } from 'web-ui-components/lib/typography/headings';
import { VerticalReviewTable } from 'web-ui-components/lib/layout/tables';
import withContent from '../../../containers/withContent';
import paymentDetailsContent, { contentPropTypes } from './BatchPaymentDetails.content';
import { formatDate, formatLongDateTime } from '../../../utils/dateUtils';
import { formatAccountDetails } from '../../../utils/accountUtils';
import { verificationPropTypes } from '../../../states/payments/propTypes';
import { formatAmount } from '../../../utils/numberUtils';
import { IndividualBatchPaymentInformation as BatchInformationPaymentTable } from './BatchInformationPaymentTable';

const BatchPaymentDetails = ({ content, payment, isFileUploadBatchPayment }) => {
	const {
		title,
		fromLabel,
		paymentDateLabel,
		createdByLabel,
		createdOnLabel,
		transactionCountLabel,
		totalAmountLabel,
		transactions,
	} = content;

	const { created_timestamp, total, payments } = payment;
	const { start_date, creator_name, from_account, file_upload } = head(payment.payments);

	const batchPaymentData = [
		{
			headerText: fromLabel,
			cellText: isFileUploadBatchPayment ? 'File upload summary' : formatAccountDetails(from_account),
		},
		{ headerText: paymentDateLabel, cellText: formatDate(start_date) },
		{ headerText: totalAmountLabel, cellText: formatAmount(total) },
		{ headerText: file_upload ? transactions : transactionCountLabel, cellText: payments.length },
		{ headerText: createdByLabel, cellText: creator_name },
		{ ...(created_timestamp ? { headerText: createdOnLabel, cellText: formatLongDateTime(created_timestamp) } : []) },
	];

	return (
		<div>
			<Grid.TwoThirds>
				<SectionHeading>{title}</SectionHeading>
				<VerticalReviewTable data={batchPaymentData} />
			</Grid.TwoThirds>
			<BatchInformationPaymentTable payments={payments} isFileUpload={file_upload} />
		</div>
	);
};

BatchPaymentDetails.propTypes = {
	content: PropTypes.shape(contentPropTypes),
	payment: PropTypes.shape(verificationPropTypes),
};

const contentWrapper = withContent({ content: paymentDetailsContent });
export default connect()(contentWrapper(BatchPaymentDetails));
export const ConnectWrapper = connect()(BatchPaymentDetails);
